import { forEach, isFunction } from "lodash";

import { InputProps } from "../types/InputProps";
import { Form } from "../types/Form";

type OnChangeCb = (fieldName: string, value: any, element: any) => void;

type ConfigBuilder<T> = (data: T) => InputProps;

export interface FieldOptions<T> {
    props: InputProps | ConfigBuilder<T>;
    fieldName?: string;
    formatter?(value: any, data: T): any;
    parser?(value: any, data: T): any;
}

export interface UiForm {
    fields: {[fieldname: string]: InputProps};
}

export class UiFormBuilder<T> {

    _fields: {[fieldname: string]: FieldOptions<T>} = {};
    _onChange: OnChangeCb;

    addField(name: string, options: FieldOptions<T>): UiFormBuilder<T> {
        this._fields[name] = options;
        return this;
    }

    build(form: Form<T>): UiForm {

        const result: UiForm = { fields: {} };

        forEach(this._fields, (options, fieldName) => {

            // Config
            let props: any = options.props;
            if (isFunction(props)) {
                props = props(form.values);
            }

            // Data
            let value = form.values[fieldName];
            if ( options.formatter ) {
                value = options.formatter(value, form.values);
            }

            // On change
            const onChangeFieldName = this._fields[fieldName].fieldName || fieldName;
            const onChange = (newValue: any, element: any) => {
                if (this._onChange) {
                    if (options.parser) {
                        newValue = options.parser(newValue, form.values);
                    }
                    this._onChange(onChangeFieldName, newValue, element);
                }
            };

            result.fields[fieldName] = {
                ...props, ...form.fields[fieldName as any], onChange, value
            };
        });

        return result;
    }

    onChange(cb: OnChangeCb): UiFormBuilder<T> {
        this._onChange = cb;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/utils/UiFormBuilder.ts